import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { isIntlToShapeLocation } from "@jutro/prop-types";
import { sanitizeUrl } from "@jutro/platform";
import { useTranslator } from "../TranslatorProvider";
export var getUrlTranslatorAndSanitizer = function getUrlTranslatorAndSanitizer(translator) {
  return function (url) {
    var allowNoLeadingSlash = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return isIntlToShapeLocation(url) ? {
      pathname: sanitizeUrl(translator(url.pathname), allowNoLeadingSlash),
      search: translator(url.search),
      hash: translator(url.hash),
      state: url.state
    } : sanitizeUrl(translator(url), allowNoLeadingSlash);
  };
};
export var useSafeTranslatedUrls = function useSafeTranslatedUrls() {
  var translator = useTranslator();
  return getUrlTranslatorAndSanitizer(translator);
};